module.exports = __webpack_public_path__ + "static/media/ic-service-survey.b11cc991.svg";